import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { BreadcrumbsModule } from "src/app/components/elementi-strutturali/breadcrumbs/breadcrumbs.module";
import { SocialShareComponent } from "src/app/shared/components/social-share/social-share.component";
import { OrgUnitLayoutComponent } from "./org-unit-layout.component";
import { ActionsListComponent } from "src/app/shared/components/actions-list/actions-list.component";
import { ContactsModule } from "src/app/components/elementi-strutturali/contacts/contacts.module";

@NgModule({
  imports: [CommonModule, RouterModule, FormsModule, BreadcrumbsModule, SocialShareComponent, ActionsListComponent, ContactsModule],
  declarations: [OrgUnitLayoutComponent],
  exports: [OrgUnitLayoutComponent],

})
export class OrgUnitLayoutModule {
  static component = OrgUnitLayoutComponent
}